// extracted by mini-css-extract-plugin
export default {"titleTable":"riskScaleAndInterpretation_titleTable__FV1SG","table":"riskScaleAndInterpretation_table__-tsJF","descriptionTable":"riskScaleAndInterpretation_descriptionTable__o0w9V"};